export default "__VITE_ASSET__SRYRU6PQ__"